import "bootstrap/dist/css/bootstrap.min.css";
import "./Assets/css/owl.carousel.min.css";
import "./Assets/css/owl.theme.default.min.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import HomePage from "./pages/HomePage";
import JobDetails from "./pages/JobDetails";

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/job-details/:jobId" element={<JobDetails />} />
          
        </Routes>
      </div>
    </Router>
  );
}

export default App;
